import React from 'react';

function NotFoundPage() {
  return <h2>Sivua ei löytynyt.</h2>;
}

export default NotFoundPage;
